import debounce from "lodash.debounce"

// Env variables
import { GTM_CONTAINER_ID } from "@/lib/env"

export const generateSendEventDebounced = (
	limit = 1000,
): ReturnType<typeof debounce<typeof sendEvent>> => {
	return debounce(sendEvent, limit)
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const sendEvent = (category: string, action: string, args?: any) => {
	if (typeof window.gtag !== "undefined") {
		window.gtag("event", category, {
			action,
			...args,
		})
	}
}

// These types are specifically for privacy-related settings and do not exist on @types/gtag
type GtagSetOptions = {
	allow_google_signals: boolean
	allow_ad_personalization_signals: boolean
	restricted_data_processing: boolean
	send_page_view: boolean
}

/**
 * Disable GTM / GA
 * DOCS: https://developers.google.com/tag-platform/security/guides/privacy#gtag.js_1
 */
export const enableGoogleTagManager = (enabled: boolean) => {
	if (enabled === false) {
		// Should stop GA from all tracking
		;(window as any)[`ga-disable-${GTM_CONTAINER_ID}`] = true

		// Disabled specific tracking features
		gtag("set", { allow_google_signals: false } as GtagSetOptions)
		gtag("set", {
			allow_ad_personalization_signals: false,
		} as GtagSetOptions)
		gtag("set", { restricted_data_processing: true } as GtagSetOptions)
		gtag("set", { send_page_view: false } as GtagSetOptions)
	}

	// Re-enable
	if (enabled === true) {
		;(window as any)[`ga-disable-${GTM_CONTAINER_ID}`] = false
		gtag("set", { allow_google_signals: true } as GtagSetOptions)
		gtag("set", {
			allow_ad_personalization_signals: true,
		} as GtagSetOptions)
		gtag("set", { restricted_data_processing: false } as GtagSetOptions)
		gtag("set", { send_page_view: true } as GtagSetOptions)
	}
}

export const GA_EVENTS = {
	FORM_SUBMIT_CONTACT: "form_submit_contact",
	BUTTON_CLICK_SIGNUP: "button_click_signup",
	VIDEO_PLAY_TUTORIAL: "video_play_tutorial",
} as const
export type GAEventName = (typeof GA_EVENTS)[keyof typeof GA_EVENTS]
